export default __webpack_public_path__ + "media/images/meals/night-7e727f554ff000fa2d619ab24d1e5e37.png";